import { Clock, EventIcon, RoundedInformationIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import {
  IconWithBackground,
  ListCardItemWithIcon,
  Paragraph,
  paragraphSizes,
  SelectDropdown,
  SelectDropdownProps,
} from '@va/ui/design-system';
import { isWebsiteErrorsEnabled } from '@va/util/helpers';
import useErrorAlertsPreferences from './useErrorAlertsPreferences';

export const ErrorAlertsThreshold = () => {
  const translate = useTranslate();
  const { thresholdDropdownValues, trackingIntervalOptions, numberOfErrorsAndEventsOptions, handleThresholdChange } =
    useErrorAlertsPreferences();

  return (
    <>
      <ListCardItemWithIcon
        className='max-w-full!'
        icon={<IconWithBackground className='bg-white' icon={() => <Clock strokeColor='#696969' />} />}
        topText={translate('form.errorAlerts.notificationThreshold')}
        bottomNode={
          <Paragraph size={paragraphSizes.tiny} colorClassName='text-primary' className={'text-devil-gray!'}>
            {translate('form.errorAlerts.notificationThresholdSubtitle')}
          </Paragraph>
        }
      />
      <div className='grid grid-cols-2 mt-3 gap-1.5px overflow-hidden rounded-15'>
        {isWebsiteErrorsEnabled() && (
          <>
            <ThresholdDropdown
              dropdownOptions={numberOfErrorsAndEventsOptions}
              onChange={({ value }) => handleThresholdChange('abeWebsiteErrorsThreshold', { limit: value })}
              selectedOption={thresholdDropdownValues.abeWebsiteErrorsThreshold.limit}
              label={translate('form.errorAlerts.threshold.numberOfErrors')}
              icon={<RoundedInformationIcon color='#696969' />}
            />
            <ThresholdDropdown
              dropdownOptions={trackingIntervalOptions}
              onChange={({ value }) => handleThresholdChange('abeWebsiteErrorsThreshold', { interval: value })}
              selectedOption={thresholdDropdownValues.abeWebsiteErrorsThreshold.interval}
              label={translate('form.errorAlerts.threshold.trackedIn')}
              icon={<Clock strokeColor='#696969' />}
            />
          </>
        )}
        <ThresholdDropdown
          dropdownOptions={numberOfErrorsAndEventsOptions}
          onChange={({ value }) => handleThresholdChange('abeNegativeEventsThreshold', { limit: value })}
          selectedOption={thresholdDropdownValues.abeNegativeEventsThreshold.limit}
          label={translate('form.errorAlerts.threshold.numberOfEvents')}
          icon={<EventIcon color='#696969' />}
        />
        <ThresholdDropdown
          dropdownOptions={trackingIntervalOptions}
          onChange={({ value }) => handleThresholdChange('abeNegativeEventsThreshold', { interval: value })}
          selectedOption={thresholdDropdownValues.abeNegativeEventsThreshold.interval}
          label={translate('form.errorAlerts.threshold.trackedIn')}
          icon={<Clock strokeColor='#696969' />}
        />
      </div>
    </>
  );
};

function ThresholdDropdown<T = string>(props: SelectDropdownProps<T>) {
  return <SelectDropdown<T> bgColor='bg-white' buttonClassName='rounded-none' size='medium' {...props} />;
}
